import gql from 'graphql-tag';

export const REPORTEESTADO = gql`
  query($entidad:Int, $idEntidad:String, $idUser:Int, $fecha1:String, $fecha2:String){
    reporteEstado(
      entidad:$entidad,
      idEntidad:$idEntidad, 
      idUser:$idUser, 
      fecha1:$fecha1, 
      fecha2:$fecha2)
      
      reporteIndGeneral(
      entidad:$entidad,
      idEntidad:$idEntidad, 
      idUser:$idUser, 
      fecha1:$fecha1, 
      fecha2:$fecha2)
  }
  
`;

export const REPORTEVENTAS = gql`
  query($entidad:Int, $idEntidad:String, $idUser:Int, $fecha1:String, $fecha2:String){
    reporteVentas(
      entidad:$entidad,
      idEntidad:$idEntidad, 
      idUser:$idUser, 
      fecha1:$fecha1, 
      fecha2:$fecha2)
  }
`;

export const REPORTEINDICADORES = gql`
  query($entidad:Int, $idEntidad:String, $idUser:Int, $fecha1:String, $fecha2:String){
    reporteIndicadores(
      entidad:$entidad,
      idEntidad:$idEntidad, 
      idUser:$idUser, 
      fecha1:$fecha1, 
      fecha2:$fecha2)
  }
`;

export const REPORTEPARTICIPACION = gql`
 query($entidad:Int, $idEntidad:String, $idUser:Int, $fecha1:String, $fecha2:String){
    reporteParticipacion(
      entidad:$entidad,
      idEntidad:$idEntidad, 
      idUser:$idUser, 
      fecha1:$fecha1, 
      fecha2:$fecha2)
  }
`;

export const REPORTEINDGENERAL = gql`
 query($entidad:Int, $idEntidad:String, $idUser:Int, $fecha1:String, $fecha2:String){
    reporteIndGeneral(
      entidad:$entidad,
      idEntidad:$idEntidad, 
      idUser:$idUser, 
      fecha1:$fecha1, 
      fecha2:$fecha2)
  }
`;

export const REPORTEMIXVENTAS = gql`
 query($entidad:Int, $idEntidad:String, $idUser:Int, $fecha1:String, $fecha2:String){
    reporteMixVentas(
      entidad:$entidad,
      idEntidad:$idEntidad, 
      idUser:$idUser, 
      fecha1:$fecha1, 
      fecha2:$fecha2)
  }
`;


export const REPORTEMIXVENTASPARTICIPANTES = gql`
    query($entidad:Int, $idEntidad:String, $idUser:Int, $fecha1:String, $fecha2:String){
        reporteMixVentasParticipantes(
            entidad:$entidad,
            idEntidad:$idEntidad,
            idUser:$idUser,
            fecha1:$fecha1,
            fecha2:$fecha2)
    }
`;

